import { useDataStore } from '@/lib/machine/use-data-store'
import { useDataStoreLocalStorage } from '@/lib/machine/use-data-store-local-storage'
import { CloudFinishInstallationInput } from '@uv/machine'

export const useCloudFinishInstallation = () => {
  const mockMode = useDataStore(s => s.mockMode)

  const cloudFinishInstallation = (installationData: CloudFinishInstallationInput) => {
    if (mockMode) {
      console.warn('Mock mode is enabled, skipping cloud finish installation')
      return
    }

    // Persist before delivery so a reboot or failed request cannot lose the finish.
    useDataStoreLocalStorage.getState().addLocalInstallationRecord({
      ...installationData,
      finishPending: true
    })
  }

  return cloudFinishInstallation
}
